<script setup lang="ts">
import { type PropType } from 'vue'
import {
	createGAEvent,
	GaGeneralEvent,
	GaGeneralPageName,
} from '@/assets/ts/customEvent'
import { isMobile } from '@/legacy/ts/checkDevice'

interface ImageSection {
	menuTitle: string
	title: string
	subtitle: string
	type: string
	webImage?: string
	url?: string
	tracking?: string
	appImage?: string
}

const props = defineProps({
	section: {
		type: Object as PropType<ImageSection>,
		required: true,
		validator: (value: any): boolean =>
			value.type === 'image' && !!value.webImage,
	},
})

const handleImageClick = () => {
	if (props.section.tracking) {
		createGAEvent(GaGeneralEvent.ButtonClick, {
			page_name: GaGeneralPageName.MercariCampaign,
			button_name: 'Promotion Banner',
			event_extra: props.section.tracking,
		})
	}
}
</script>

<template>
	<div class="flex flex-col gap-casual-friends overflow-hidden">
		<div class="flex flex-col gap-strong-friends">
			<h2 class="typography-h3-str">
				{{ section.title }}
			</h2>
			<h4 class="typography-s1-reg">{{ section.subtitle }}</h4>
		</div>

		<a
			v-if="section.url"
			:href="section.url"
			target="_blank"
			class="block"
			@click="handleImageClick"
		>
			<img
				:srcset="isMobile ? section.appImage : section.webImage"
				:alt="section.title"
				class="w-full"
				loading="lazy"
			/>
		</a>

		<div v-else class="block">
			<img
				:src="section.webImage"
				:alt="section.title"
				class="w-full"
				loading="lazy"
			/>
		</div>
	</div>
</template>
